import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, vModelSelect as _vModelSelect, vModelText as _vModelText, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "saving-overlay"
}
const _hoisted_2 = {
  key: 1,
  class: "saving-overlay"
}
const _hoisted_3 = {
  key: 0,
  class: "sfv-topbar"
}
const _hoisted_4 = { class: "sfv-topbar-left" }
const _hoisted_5 = { class: "sfv-topbar-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "sfv-context-bar"
}
const _hoisted_8 = { class: "sfv-context-type" }
const _hoisted_9 = { class: "sfv-context-project" }
const _hoisted_10 = { class: "sfv-context-date" }
const _hoisted_11 = { class: "sfv-body" }
const _hoisted_12 = { class: "sfv-section type-section" }
const _hoisted_13 = { class: "type-picker-label" }
const _hoisted_14 = {
  key: 0,
  class: "type-grid-wrap"
}
const _hoisted_15 = { class: "type-grid" }
const _hoisted_16 = { class: "sfv-section" }
const _hoisted_17 = { class: "fields-row-3" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "field" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = {
  class: "lang-select-wrap",
  ref: "langDropdownRef"
}
const _hoisted_23 = { class: "lang-btn-flag" }
const _hoisted_24 = { class: "lang-select-label" }
const _hoisted_25 = {
  key: 0,
  class: "lang-select-dropdown"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "lang-btn-flag" }
const _hoisted_28 = {
  key: 0,
  class: "lang-check",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}
const _hoisted_29 = {
  key: 0,
  class: "field",
  style: {"margin-top":"14px"}
}
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 0,
  class: "alert alert-warn"
}
const _hoisted_32 = { class: "alert-body" }
const _hoisted_33 = { class: "alert-actions" }
const _hoisted_34 = {
  key: 1,
  class: "copy-banner"
}
const _hoisted_35 = { class: "sfv-section list-section" }
const _hoisted_36 = { class: "section-head" }
const _hoisted_37 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_38 = {
  key: 1,
  class: "list-items"
}
const _hoisted_39 = { class: "list-item-avatar" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "sfv-section list-section" }
const _hoisted_43 = { class: "coauthor-area" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "coauthor-picker-wrap",
  ref: "coAuthorPickerRef"
}
const _hoisted_46 = {
  key: 0,
  class: "coauthor-dropdown"
}
const _hoisted_47 = { class: "coauthor-dropdown-list" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "coauthor-dropdown-name" }
const _hoisted_50 = { class: "coauthor-dropdown-user" }
const _hoisted_51 = {
  key: 0,
  class: "coauthor-dropdown-empty"
}
const _hoisted_52 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_53 = { class: "sfv-section expandable-section" }
const _hoisted_54 = { class: "section-head" }
const _hoisted_55 = {
  key: 0,
  class: "expandable-list"
}
const _hoisted_56 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_57 = { class: "flip-card-back" }
const _hoisted_58 = { class: "flip-confirm-label" }
const _hoisted_59 = { class: "flip-confirm-actions" }
const _hoisted_60 = { class: "flip-card-front expandable-item" }
const _hoisted_61 = { class: "expandable-item-header" }
const _hoisted_62 = { class: "item-badge" }
const _hoisted_63 = { class: "item-title" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  class: "field",
  style: {"margin-bottom":"14px"}
}
const _hoisted_66 = ["for"]
const _hoisted_67 = ["id", "onUpdate:modelValue"]
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "field" }
const _hoisted_70 = { class: "img-count" }
const _hoisted_71 = ["onDragenter", "onDragover", "onDragleave", "onDrop"]
const _hoisted_72 = ["src"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["id", "onChange"]
const _hoisted_76 = { class: "sfv-section expandable-section" }
const _hoisted_77 = { class: "section-head" }
const _hoisted_78 = {
  key: 0,
  class: "expandable-list"
}
const _hoisted_79 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_80 = { class: "flip-card-back" }
const _hoisted_81 = { class: "flip-confirm-label" }
const _hoisted_82 = { class: "flip-confirm-actions" }
const _hoisted_83 = { class: "flip-card-front expandable-item" }
const _hoisted_84 = { class: "expandable-item-header" }
const _hoisted_85 = { class: "item-badge" }
const _hoisted_86 = { class: "item-title" }
const _hoisted_87 = ["disabled", "onClick"]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = {
  class: "field",
  style: {"margin-bottom":"14px"}
}
const _hoisted_90 = ["for"]
const _hoisted_91 = ["id", "onUpdate:modelValue"]
const _hoisted_92 = {
  key: 0,
  class: "ia-suggestion"
}
const _hoisted_93 = { class: "ia-suggestion-text" }
const _hoisted_94 = { class: "ia-suggestion-actions" }
const _hoisted_95 = { class: "field" }
const _hoisted_96 = { class: "img-count" }
const _hoisted_97 = ["onDragenter", "onDragover", "onDragleave", "onDrop"]
const _hoisted_98 = ["src"]
const _hoisted_99 = ["onClick"]
const _hoisted_100 = ["onClick"]
const _hoisted_101 = ["id", "onChange"]
const _hoisted_102 = { class: "sfv-section expandable-section" }
const _hoisted_103 = { class: "section-head" }
const _hoisted_104 = {
  key: 0,
  class: "expandable-list"
}
const _hoisted_105 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_106 = { class: "flip-card-back" }
const _hoisted_107 = { class: "flip-confirm-label" }
const _hoisted_108 = { class: "flip-confirm-actions" }
const _hoisted_109 = { class: "flip-card-front expandable-item" }
const _hoisted_110 = { class: "expandable-item-header" }
const _hoisted_111 = { class: "item-badge" }
const _hoisted_112 = { class: "item-title" }
const _hoisted_113 = ["disabled", "onClick"]
const _hoisted_114 = ["onClick"]
const _hoisted_115 = {
  class: "field",
  style: {"margin-bottom":"14px"}
}
const _hoisted_116 = ["for"]
const _hoisted_117 = ["id", "onUpdate:modelValue"]
const _hoisted_118 = {
  key: 0,
  class: "ia-suggestion"
}
const _hoisted_119 = { class: "ia-suggestion-text" }
const _hoisted_120 = { class: "ia-suggestion-actions" }
const _hoisted_121 = { class: "field" }
const _hoisted_122 = { class: "img-count" }
const _hoisted_123 = ["onDragenter", "onDragover", "onDragleave", "onDrop"]
const _hoisted_124 = ["src"]
const _hoisted_125 = ["onClick"]
const _hoisted_126 = ["onClick"]
const _hoisted_127 = ["id", "onChange"]
const _hoisted_128 = {
  id: "requisicao-section",
  class: "sfv-section expandable-section"
}
const _hoisted_129 = { class: "section-head" }
const _hoisted_130 = {
  key: 0,
  class: "req-empty-hint"
}
const _hoisted_131 = {
  key: 1,
  class: "expandable-list"
}
const _hoisted_132 = { class: "item-row" }
const _hoisted_133 = { class: "flip-card-back" }
const _hoisted_134 = { class: "flip-confirm-label" }
const _hoisted_135 = { class: "flip-confirm-actions" }
const _hoisted_136 = { class: "flip-card-front expandable-item" }
const _hoisted_137 = { class: "expandable-item-header" }
const _hoisted_138 = { class: "item-badge" }
const _hoisted_139 = { class: "item-title" }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = {
  class: "field",
  style: {"margin-bottom":"14px"}
}
const _hoisted_142 = ["for"]
const _hoisted_143 = ["id", "onUpdate:modelValue"]
const _hoisted_144 = {
  class: "field",
  style: {"margin-bottom":"14px"}
}
const _hoisted_145 = ["for"]
const _hoisted_146 = ["id", "onUpdate:modelValue"]
const _hoisted_147 = {
  class: "field",
  style: {"margin-bottom":"14px"}
}
const _hoisted_148 = ["for"]
const _hoisted_149 = ["id", "onUpdate:modelValue"]
const _hoisted_150 = { class: "field" }
const _hoisted_151 = { class: "img-count" }
const _hoisted_152 = ["onDragenter", "onDragover", "onDragleave", "onDrop"]
const _hoisted_153 = ["src"]
const _hoisted_154 = ["onClick"]
const _hoisted_155 = ["onClick"]
const _hoisted_156 = ["id", "onChange"]
const _hoisted_157 = {
  key: 2,
  class: "sfv-error"
}
const _hoisted_158 = { class: "sfv-bottom-bar" }
const _hoisted_159 = { class: "sfv-bb-left" }
const _hoisted_160 = ["disabled"]
const _hoisted_161 = ["disabled"]
const _hoisted_162 = { class: "sfv-bb-right" }
const _hoisted_163 = ["disabled"]
const _hoisted_164 = ["disabled"]
const _hoisted_165 = {
  key: 0,
  class: "tool-request-prompt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoticeModal = _resolveComponent("NoticeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[50] || (_cache[50] = [
          _createElementVNode("div", { class: "saving-card" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              class: "spin-icon"
            }, [
              _createElementVNode("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-dasharray": "40",
                "stroke-dashoffset": "15",
                "stroke-linecap": "round"
              })
            ]),
            _createTextVNode(" Carregando… ")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.isSaving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[51] || (_cache[51] = [
          _createElementVNode("div", { class: "saving-card" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              class: "spin-icon"
            }, [
              _createElementVNode("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-dasharray": "40",
                "stroke-dashoffset": "15",
                "stroke-linecap": "round"
              })
            ]),
            _createTextVNode(" Salvando dados… ")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["sfv-page", { embedded: _ctx.embedded }])
    }, [
      (!_ctx.embedded)
        ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "sfv-topbar-back",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, [...(_cache[52] || (_cache[52] = [
                _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 16 16",
                  fill: "none"
                }, [
                  _createElementVNode("path", {
                    d: "M10 3L5 8l5 5",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1),
                _createTextVNode(" Voltar ", -1)
              ]))]),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.isEdit ? 'Editar Relatório' : 'Novo Relatório') + " ", 1),
                (_ctx.attraction)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · " + _toDisplayString(_ctx.attraction), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              class: "sfv-topbar-esc",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, "Esc para cancelar")
          ]))
        : _createCommentVNode("", true),
      (_ctx.embedded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[55] || (_cache[55] = _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 18 18",
              fill: "none"
            }, [
              _createElementVNode("rect", {
                x: "3",
                y: "3",
                width: "12",
                height: "12",
                rx: "2",
                stroke: "currentColor",
                "stroke-width": "1.5"
              }),
              _createElementVNode("path", {
                d: "M6 7h6M6 9.5h4",
                stroke: "currentColor",
                "stroke-width": "1.3",
                "stroke-linecap": "round"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.reportTypeLabel || (_ctx.isEdit ? 'Editar Relatório' : 'Novo Relatório')), 1),
            (_ctx.attraction)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[53] || (_cache[53] = _createElementVNode("span", { class: "sfv-context-sep" }, "·", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.attraction), 1)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.reportDate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[54] || (_cache[54] = _createElementVNode("span", { class: "sfv-context-sep" }, "·", -1)),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.reportDate.split('-').reverse().join('/')), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("form", {
          class: "sfv-form",
          onSubmit: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "type-picker-trigger",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.typePickerOpen = !_ctx.typePickerOpen))
            }, [
              _createElementVNode("span", _hoisted_13, [
                _cache[56] || (_cache[56] = _createTextVNode(" Tipo de relatório: ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.reportTypeLabel || 'Selecione'), 1)
              ]),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["type-picker-chevron", { open: _ctx.typePickerOpen }]),
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [...(_cache[57] || (_cache[57] = [
                _createElementVNode("path", {
                  d: "M3 5l4 4 4-4",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))], 2))
            ]),
            _createVNode(_Transition, { name: "type-expand" }, {
              default: _withCtx(() => [
                (_ctx.typePickerOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", {
                          class: _normalizeClass(["type-card", { active: _ctx.reportType === 'Relatorio diario de obra' }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "reportType",
                            value: "Relatorio diario de obra",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reportType) = $event)),
                            class: "sr-only",
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.typePickerOpen = false))
                          }, null, 544), [
                            [_vModelRadio, _ctx.reportType]
                          ]),
                          _cache[58] || (_cache[58] = _createElementVNode("div", { class: "type-check" }, "✓", -1)),
                          _cache[59] || (_cache[59] = _createElementVNode("div", { class: "type-icon type-icon--daily" }, [
                            _createElementVNode("svg", {
                              width: "18",
                              height: "18",
                              viewBox: "0 0 18 18",
                              fill: "none"
                            }, [
                              _createElementVNode("rect", {
                                x: "3",
                                y: "3",
                                width: "12",
                                height: "12",
                                rx: "2",
                                stroke: "currentColor",
                                "stroke-width": "1.5"
                              }),
                              _createElementVNode("path", {
                                d: "M6 7h6M6 9.5h4",
                                stroke: "currentColor",
                                "stroke-width": "1.3",
                                "stroke-linecap": "round"
                              })
                            ])
                          ], -1)),
                          _cache[60] || (_cache[60] = _createElementVNode("div", { class: "type-name" }, "Diário", -1)),
                          _cache[61] || (_cache[61] = _createElementVNode("div", { class: "type-desc" }, "Registro diário de obra", -1))
                        ], 2),
                        _createElementVNode("label", {
                          class: _normalizeClass(["type-card", { active: _ctx.reportType === 'Relatorio de incidente' }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "reportType",
                            value: "Relatorio de incidente",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reportType) = $event)),
                            class: "sr-only",
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.typePickerOpen = false))
                          }, null, 544), [
                            [_vModelRadio, _ctx.reportType]
                          ]),
                          _cache[62] || (_cache[62] = _createElementVNode("div", { class: "type-check" }, "✓", -1)),
                          _cache[63] || (_cache[63] = _createElementVNode("div", { class: "type-icon type-icon--incident" }, [
                            _createElementVNode("svg", {
                              width: "18",
                              height: "18",
                              viewBox: "0 0 18 18",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                d: "M9 5v4M9 12h.01",
                                stroke: "currentColor",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round"
                              }),
                              _createElementVNode("circle", {
                                cx: "9",
                                cy: "9",
                                r: "6",
                                stroke: "currentColor",
                                "stroke-width": "1.5"
                              })
                            ])
                          ], -1)),
                          _cache[64] || (_cache[64] = _createElementVNode("div", { class: "type-name" }, "Incidente", -1)),
                          _cache[65] || (_cache[65] = _createElementVNode("div", { class: "type-desc" }, "Ocorrência ou anomalia", -1))
                        ], 2),
                        _createElementVNode("label", {
                          class: _normalizeClass(["type-card", { active: _ctx.reportType === 'Relatorio geral' }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "reportType",
                            value: "Relatorio geral",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reportType) = $event)),
                            class: "sr-only",
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.typePickerOpen = false))
                          }, null, 544), [
                            [_vModelRadio, _ctx.reportType]
                          ]),
                          _cache[66] || (_cache[66] = _createElementVNode("div", { class: "type-check" }, "✓", -1)),
                          _cache[67] || (_cache[67] = _createElementVNode("div", { class: "type-icon type-icon--general" }, [
                            _createElementVNode("svg", {
                              width: "18",
                              height: "18",
                              viewBox: "0 0 18 18",
                              fill: "none"
                            }, [
                              _createElementVNode("rect", {
                                x: "3",
                                y: "4",
                                width: "12",
                                height: "10",
                                rx: "2",
                                stroke: "currentColor",
                                "stroke-width": "1.5"
                              }),
                              _createElementVNode("path", {
                                d: "M6 8h6M6 10.5h3",
                                stroke: "currentColor",
                                "stroke-width": "1.3",
                                "stroke-linecap": "round"
                              })
                            ])
                          ], -1)),
                          _cache[68] || (_cache[68] = _createElementVNode("div", { class: "type-name" }, "Geral", -1)),
                          _cache[69] || (_cache[69] = _createElementVNode("div", { class: "type-desc" }, "Relatório de uso geral", -1))
                        ], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[76] || (_cache[76] = _createElementVNode("div", { class: "section-head" }, [
              _createElementVNode("div", { class: "section-label" }, "Dados Gerais")
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[70] || (_cache[70] = _createElementVNode("label", { for: "attraction" }, "Projeto", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "attraction",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.attraction) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_19))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.attraction]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[71] || (_cache[71] = _createElementVNode("label", { for: "reportDate" }, "Data", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "reportDate",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.reportDate) = $event)),
                  type: "date"
                }, null, 512), [
                  [_vModelText, _ctx.reportDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[74] || (_cache[74] = _createElementVNode("label", null, "Idioma", -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "lang-select-trigger",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showLangDropdown = !_ctx.showLangDropdown))
                  }, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.REPORT_LANGUAGES.find(l => l.code === _ctx.reportLanguage)?.flag), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.REPORT_LANGUAGES.find(l => l.code === _ctx.reportLanguage)?.label), 1),
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(["lang-select-chevron", { open: _ctx.showLangDropdown }]),
                      width: "12",
                      height: "12",
                      viewBox: "0 0 12 12",
                      fill: "none"
                    }, [...(_cache[72] || (_cache[72] = [
                      _createElementVNode("path", {
                        d: "M2 4l4 4 4-4",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)
                    ]))], 2))
                  ]),
                  (_ctx.showLangDropdown)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.REPORT_LANGUAGES, (loc) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: loc.code,
                            type: "button",
                            class: _normalizeClass(["lang-select-option", { active: _ctx.reportLanguage === loc.code }]),
                            onClick: ($event: any) => {_ctx.reportLanguage = loc.code; _ctx.showLangDropdown = false}
                          }, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(loc.flag), 1),
                            _createElementVNode("span", null, _toDisplayString(loc.label), 1),
                            (_ctx.reportLanguage === loc.code)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_28, [...(_cache[73] || (_cache[73] = [
                                  _createElementVNode("path", {
                                    d: "M2 6l3 3 5-5",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_26))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 512)
              ])
            ]),
            (_ctx.isAdminUser && !_ctx.isEdit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _cache[75] || (_cache[75] = _createElementVNode("label", { for: "report-author" }, "Criar em nome de", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "report-author",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.createdOnBehalfOfUsername) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorOptions, (user) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: user.username,
                        value: user.username
                      }, _toDisplayString(user.name) + " (" + _toDisplayString(user.username) + ") ", 9, _hoisted_30))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.createdOnBehalfOfUsername]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.duplicateSubmission && !_ctx.suppressDuplicateWarning)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _cache[80] || (_cache[80] = _createElementVNode("div", { class: "alert-icon" }, "!", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _cache[77] || (_cache[77] = _createTextVNode(" Já existe um ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.reportTypeLabel), 1),
                  _cache[78] || (_cache[78] = _createTextVNode(" para ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.attraction), 1),
                  _cache[79] || (_cache[79] = _createTextVNode(" nesta data. ", -1))
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    class: "alert-btn",
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.editExistingReport && _ctx.editExistingReport(...args)))
                  }, "Editar existente"),
                  _createElementVNode("button", {
                    class: "alert-btn alert-btn--fill",
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.suppressDuplicateWarning = true))
                  }, "Continuar")
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isEdit && _ctx.reportType === 'Relatorio diario de obra')
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _cache[81] || (_cache[81] = _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 15 15",
                  fill: "none"
                }, [
                  _createElementVNode("rect", {
                    x: "4",
                    y: "1",
                    width: "9",
                    height: "12",
                    rx: "1.5",
                    stroke: "currentColor",
                    "stroke-width": "1.3"
                  }),
                  _createElementVNode("rect", {
                    x: "2",
                    y: "3",
                    width: "9",
                    height: "12",
                    rx: "1.5",
                    stroke: "currentColor",
                    "stroke-width": "1.3",
                    fill: "var(--bg,#faf9f6)"
                  }),
                  _createElementVNode("path", {
                    d: "M5 7h5M5 9.5h3",
                    stroke: "currentColor",
                    "stroke-width": "1.2",
                    "stroke-linecap": "round"
                  })
                ], -1)),
                _cache[82] || (_cache[82] = _createElementVNode("span", null, "Preencher com o último relatório", -1)),
                _createElementVNode("button", {
                  class: "copy-banner-btn",
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.copyFromLatestDailyReport && _ctx.copyFromLatestDailyReport(...args)))
                }, "Copiar dados")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[83] || (_cache[83] = _createElementVNode("div", { class: "section-label" }, "Colaboradores Presentes", -1)),
              _createElementVNode("button", {
                class: "btn-inline",
                type: "button",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.addCollaborator && _ctx.addCollaborator(...args)))
              }, "+ Adicionar")
            ]),
            (_ctx.collaborators.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Nenhum colaborador adicionado"))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collaborators, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `colab-${index}`,
                      class: "list-item"
                    }, [
                      _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.getInitials(_ctx.collaborators[index])), 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "list-item-input",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.collaborators[index]) = $event),
                        type: "text",
                        placeholder: "Nome ou função"
                      }, null, 8, _hoisted_40), [
                        [_vModelText, _ctx.collaborators[index]]
                      ]),
                      _createElementVNode("button", {
                        class: "list-item-remove",
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeCollaborator(index)),
                        title: "Remover",
                        "aria-label": "Remover"
                      }, [...(_cache[84] || (_cache[84] = [
                        _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 12 12",
                          fill: "none"
                        }, [
                          _createElementVNode("path", {
                            d: "M2 6h8",
                            stroke: "currentColor",
                            "stroke-width": "1.6",
                            "stroke-linecap": "round"
                          })
                        ], -1)
                      ]))], 8, _hoisted_41)
                    ]))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_42, [
            _cache[87] || (_cache[87] = _createElementVNode("div", { class: "section-head no-mb" }, [
              _createElementVNode("div", { class: "section-label" }, "Co-autores")
            ], -1)),
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coAuthors, (username) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: username,
                  class: "coauthor-chip"
                }, [
                  _cache[86] || (_cache[86] = _createElementVNode("svg", {
                    width: "11",
                    height: "11",
                    viewBox: "0 0 16 16",
                    fill: "none"
                  }, [
                    _createElementVNode("circle", {
                      cx: "8",
                      cy: "6",
                      r: "3",
                      stroke: "currentColor",
                      "stroke-width": "1.5"
                    }),
                    _createElementVNode("path", {
                      d: "M2 14c0-3.314 2.686-6 6-6s6 2.686 6 6",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.resolveCoAuthorName(username)) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "coauthor-chip-rm",
                    onClick: ($event: any) => (_ctx.removeCoAuthor(username)),
                    title: "Remover"
                  }, [...(_cache[85] || (_cache[85] = [
                    _createElementVNode("svg", {
                      width: "9",
                      height: "9",
                      viewBox: "0 0 10 10",
                      fill: "none"
                    }, [
                      _createElementVNode("path", {
                        d: "M2 2l6 6M8 2L2 8",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round"
                      })
                    ], -1)
                  ]))], 8, _hoisted_44)
                ]))
              }), 128)),
              (_ctx.coAuthorPickerOptions.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-inline",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.coAuthorPickerOpen = !_ctx.coAuthorPickerOpen))
                    }, "+ Adicionar"),
                    (_ctx.coAuthorPickerOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.coAuthorSearch) = $event)),
                            class: "coauthor-search",
                            type: "text",
                            placeholder: "Buscar usuário…",
                            autofocus: ""
                          }, null, 512), [
                            [_vModelText, _ctx.coAuthorSearch]
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCoAuthorOptions, (user) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: user.username,
                                type: "button",
                                class: "coauthor-dropdown-item",
                                onClick: ($event: any) => (_ctx.addCoAuthor(user.username))
                              }, [
                                _createElementVNode("span", _hoisted_49, _toDisplayString(user.name), 1),
                                _createElementVNode("span", _hoisted_50, "@" + _toDisplayString(user.username), 1)
                              ], 8, _hoisted_48))
                            }), 128)),
                            (_ctx.filteredCoAuthorOptions.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, " Nenhum usuário encontrado "))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512))
                : _createCommentVNode("", true),
              (_ctx.coAuthors.length === 0 && _ctx.coAuthorPickerOptions.length === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, " Nenhum usuário disponível "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _cache[88] || (_cache[88] = _createElementVNode("div", { class: "section-label" }, "Maquinário Utilizado", -1)),
              _createElementVNode("button", {
                class: "btn-inline",
                type: "button",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addTool && _ctx.addTool(...args)))
              }, "+ Adicionar")
            ]),
            (_ctx.tools.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tools, (section, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `tool-${section.id}`,
                      class: _normalizeClass(["item-row-wrap", { 'item-row-wrap--removing': _ctx.deletingId === section.id }])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-row", { 'item-row--drag-over': _ctx.dragSrcType === 'tools' && _ctx.dragOverItemIdx === index && _ctx.dragSrcIdx !== index }]),
                        draggable: "true",
                        onDragstart: ($event: any) => (_ctx.onItemDragStart(index, 'tools', $event)),
                        onDragover: _withModifiers(($event: any) => (_ctx.onItemDragOver(index, 'tools')), ["prevent"]),
                        onDrop: _withModifiers(($event: any) => (_ctx.onItemDrop(index, 'tools')), ["prevent"]),
                        onDragend: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onItemDragEnd && _ctx.onItemDragEnd(...args)))
                      }, [
                        _cache[94] || (_cache[94] = _createStaticVNode("<div class=\"drag-handle\" title=\"Arrastar para reordenar\" data-v-223c034c><svg width=\"10\" height=\"14\" viewBox=\"0 0 10 14\" fill=\"none\" data-v-223c034c><circle cx=\"3\" cy=\"3\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"3\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"3\" cy=\"7\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"7\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"3\" cy=\"11\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"11\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle></svg></div>", 1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["flip-card", { 'flip-card--flipped': _ctx.deletePending?.type === 'tools' && _ctx.deletePending.index === index }])
                        }, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("p", _hoisted_58, "Remover maquinário " + _toDisplayString(index + 1) + "?", 1),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("button", {
                                class: "flip-btn flip-btn--yes",
                                type: "button",
                                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                              }, "Sim, remover"),
                              _createElementVNode("button", {
                                class: "flip-btn flip-btn--no",
                                type: "button",
                                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
                              }, "Não")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, _toDisplayString(index + 1), 1),
                              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.getMachineTitle(section.text) || `Maquinário ${index + 1}`), 1),
                              _createElementVNode("button", {
                                class: "item-remove-btn",
                                type: "button",
                                onClick: ($event: any) => (_ctx.askDelete('tools', index)),
                                title: "Remover"
                              }, [...(_cache[89] || (_cache[89] = [
                                _createElementVNode("svg", {
                                  width: "13",
                                  height: "13",
                                  viewBox: "0 0 14 14",
                                  fill: "none"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M2 3.5h10M5.5 3.5V2.5h3V3.5M4.5 3.5v7.5h5V3.5",
                                    stroke: "currentColor",
                                    "stroke-width": "1.3",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  })
                                ], -1),
                                _createTextVNode(" Remover ", -1)
                              ]))], 8, _hoisted_64)
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("label", {
                                for: `tool-text-${section.id}`
                              }, "Maquinário", 8, _hoisted_66),
                              _withDirectives(_createElementVNode("select", {
                                id: `tool-text-${section.id}`,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.tools[index].text) = $event)
                              }, [
                                _cache[90] || (_cache[90] = _createElementVNode("option", { value: "" }, "Selecione o maquinário", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machineryOptions, (m) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: m.id,
                                    value: m.id
                                  }, _toDisplayString(m.title), 9, _hoisted_68))
                                }), 128))
                              ], 8, _hoisted_67), [
                                [_vModelSelect, _ctx.tools[index].text]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("label", null, [
                                _cache[91] || (_cache[91] = _createTextVNode("Fotos ", -1)),
                                _createElementVNode("span", _hoisted_70, _toDisplayString(section.images.length) + "/25", 1)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["image-grid", { 'is-drag-over': _ctx.dragOverToolId === section.id }]),
                                onDragenter: _withModifiers(($event: any) => (_ctx.dragOverToolId = section.id), ["prevent"]),
                                onDragover: _withModifiers(($event: any) => (_ctx.dragOverToolId = section.id), ["prevent"]),
                                onDragleave: _withModifiers(($event: any) => (_ctx.dragOverToolId = _ctx.dragOverToolId === section.id ? '' : _ctx.dragOverToolId), ["prevent"]),
                                onDrop: _withModifiers(($event: any) => (_ctx.onToolImagesDropped(section.id, $event)), ["prevent"])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.images, (img, imgIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: `tool-${section.id}-img-${imgIndex}`,
                                    class: "image-preview"
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.resolveUrl(img),
                                      alt: "preview"
                                    }, null, 8, _hoisted_72),
                                    _createElementVNode("button", {
                                      class: "image-remove",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.removeToolImage(section.id, imgIndex)),
                                      "aria-label": "Remover foto"
                                    }, [...(_cache[92] || (_cache[92] = [
                                      _createElementVNode("span", {
                                        class: "trash-icon",
                                        "aria-hidden": "true"
                                      }, null, -1)
                                    ]))], 8, _hoisted_73)
                                  ]))
                                }), 128)),
                                (section.images.length < 25)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "image-add",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.triggerToolImageInput(section.id))
                                    }, [...(_cache[93] || (_cache[93] = [
                                      _createElementVNode("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M9 4v10M4 9h10",
                                          stroke: "currentColor",
                                          "stroke-width": "1.6",
                                          "stroke-linecap": "round"
                                        })
                                      ], -1)
                                    ]))], 8, _hoisted_74))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_71),
                              _createElementVNode("input", {
                                id: `file-tool-${section.id}`,
                                class: "hidden-input",
                                type: "file",
                                accept: "image/*",
                                multiple: "",
                                onChange: ($event: any) => (_ctx.onToolImagesSelected(section.id, $event))
                              }, null, 40, _hoisted_75)
                            ])
                          ])
                        ], 2)
                      ], 42, _hoisted_56)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-add-bottom",
              type: "button",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addTool && _ctx.addTool(...args)))
            }, [...(_cache[95] || (_cache[95] = [
              _createElementVNode("svg", {
                width: "12",
                height: "12",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M7 3v8M3 7h8",
                  stroke: "currentColor",
                  "stroke-width": "1.4",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Adicionar maquinário ", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _cache[96] || (_cache[96] = _createElementVNode("div", { class: "section-label" }, "Atividades Executadas", -1)),
              _createElementVNode("button", {
                class: "btn-inline",
                type: "button",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.addActivity && _ctx.addActivity(...args)))
              }, "+ Adicionar")
            ]),
            (_ctx.activities.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (activity, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: activity.id,
                      class: _normalizeClass(["item-row-wrap", { 'item-row-wrap--removing': _ctx.deletingId === activity.id }])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-row", { 'item-row--drag-over': _ctx.dragSrcType === 'activities' && _ctx.dragOverItemIdx === index && _ctx.dragSrcIdx !== index }]),
                        draggable: "true",
                        onDragstart: ($event: any) => (_ctx.onItemDragStart(index, 'activities', $event)),
                        onDragover: _withModifiers(($event: any) => (_ctx.onItemDragOver(index, 'activities')), ["prevent"]),
                        onDrop: _withModifiers(($event: any) => (_ctx.onItemDrop(index, 'activities')), ["prevent"]),
                        onDragend: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.onItemDragEnd && _ctx.onItemDragEnd(...args)))
                      }, [
                        _cache[103] || (_cache[103] = _createStaticVNode("<div class=\"drag-handle\" title=\"Arrastar para reordenar\" data-v-223c034c><svg width=\"10\" height=\"14\" viewBox=\"0 0 10 14\" fill=\"none\" data-v-223c034c><circle cx=\"3\" cy=\"3\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"3\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"3\" cy=\"7\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"7\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"3\" cy=\"11\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"11\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle></svg></div>", 1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["flip-card", { 'flip-card--flipped': _ctx.deletePending?.type === 'activities' && _ctx.deletePending.index === index }])
                        }, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("p", _hoisted_81, "Excluir atividade " + _toDisplayString(index + 1) + "?", 1),
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("button", {
                                class: "flip-btn flip-btn--yes",
                                type: "button",
                                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                              }, "Sim, excluir"),
                              _createElementVNode("button", {
                                class: "flip-btn flip-btn--no",
                                type: "button",
                                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
                              }, "Não")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("div", _hoisted_85, _toDisplayString(index + 1), 1),
                              _createElementVNode("span", _hoisted_86, "Atividade " + _toDisplayString(index + 1), 1),
                              (_ctx.canUseIA && activity.description.trim())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn-ai-item",
                                    type: "button",
                                    disabled: _ctx.iaRewrite?.type === 'activities' && _ctx.iaRewrite.index === index && _ctx.iaRewrite.loading,
                                    onClick: ($event: any) => (_ctx.triggerIaRewrite('activities', index))
                                  }, [
                                    _cache[97] || (_cache[97] = _createElementVNode("svg", {
                                      width: "11",
                                      height: "11",
                                      viewBox: "0 0 14 14",
                                      fill: "none"
                                    }, [
                                      _createElementVNode("path", {
                                        d: "M7 1v2M7 11v2M1 7h2M11 7h2M2.8 2.8l1.4 1.4M9.8 9.8l1.4 1.4M2.8 11.2l1.4-1.4M9.8 4.2l1.4-1.4",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3",
                                        "stroke-linecap": "round"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.iaRewrite?.type === 'activities' && _ctx.iaRewrite.index === index && _ctx.iaRewrite.loading ? 'Processando…' : 'Modo IA'), 1)
                                  ], 8, _hoisted_87))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "item-remove-btn",
                                type: "button",
                                onClick: ($event: any) => (_ctx.askDelete('activities', index)),
                                title: "Excluir"
                              }, [...(_cache[98] || (_cache[98] = [
                                _createElementVNode("svg", {
                                  width: "13",
                                  height: "13",
                                  viewBox: "0 0 14 14",
                                  fill: "none"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M2 3.5h10M5.5 3.5V2.5h3V3.5M4.5 3.5v7.5h5V3.5",
                                    stroke: "currentColor",
                                    "stroke-width": "1.3",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  })
                                ], -1),
                                _createTextVNode(" Excluir ", -1)
                              ]))], 8, _hoisted_88)
                            ]),
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("label", {
                                for: `activity-${activity.id}`
                              }, "Descrição", 8, _hoisted_90),
                              _withDirectives(_createElementVNode("textarea", {
                                id: `activity-${activity.id}`,
                                "onUpdate:modelValue": ($event: any) => ((activity.description) = $event),
                                class: "item-textarea",
                                placeholder: "Descrição breve da atividade",
                                rows: "3"
                              }, null, 8, _hoisted_91), [
                                [_vModelText, activity.description]
                              ]),
                              (_ctx.iaRewrite && _ctx.iaRewrite.type === 'activities' && _ctx.iaRewrite.index === index && !_ctx.iaRewrite.loading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                    _cache[99] || (_cache[99] = _createElementVNode("div", { class: "ia-suggestion-label" }, [
                                      _createElementVNode("svg", {
                                        width: "11",
                                        height: "11",
                                        viewBox: "0 0 14 14",
                                        fill: "none"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M7 1v2M7 11v2M1 7h2M11 7h2M2.8 2.8l1.4 1.4M9.8 9.8l1.4 1.4M2.8 11.2l1.4-1.4M9.8 4.2l1.4-1.4",
                                          stroke: "currentColor",
                                          "stroke-width": "1.3",
                                          "stroke-linecap": "round"
                                        })
                                      ]),
                                      _createTextVNode(" Sugestão da IA ")
                                    ], -1)),
                                    _createElementVNode("p", _hoisted_93, _toDisplayString(_ctx.iaRewrite.result), 1),
                                    _createElementVNode("div", _hoisted_94, [
                                      _createElementVNode("button", {
                                        class: "ia-btn ia-btn--accept",
                                        type: "button",
                                        onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.acceptIaRewrite && _ctx.acceptIaRewrite(...args)))
                                      }, "Manter"),
                                      _createElementVNode("button", {
                                        class: "ia-btn ia-btn--dismiss",
                                        type: "button",
                                        onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.dismissIaRewrite && _ctx.dismissIaRewrite(...args)))
                                      }, "Descartar")
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("label", null, [
                                _cache[100] || (_cache[100] = _createTextVNode("Fotos ", -1)),
                                _createElementVNode("span", _hoisted_96, _toDisplayString(activity.images.length) + "/25", 1)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["image-grid", { 'is-drag-over': _ctx.dragOverActivityId === activity.id }]),
                                onDragenter: _withModifiers(($event: any) => (_ctx.onImageDragEnter(activity.id)), ["prevent"]),
                                onDragover: _withModifiers(($event: any) => (_ctx.onImageDragEnter(activity.id)), ["prevent"]),
                                onDragleave: _withModifiers(($event: any) => (_ctx.onImageDragLeave(activity.id)), ["prevent"]),
                                onDrop: _withModifiers(($event: any) => (_ctx.onImagesDropped(activity.id, $event)), ["prevent"])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.images, (img, imgIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: `${activity.id}-img-${imgIndex}`,
                                    class: "image-preview"
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.resolveUrl(img),
                                      alt: "preview"
                                    }, null, 8, _hoisted_98),
                                    _createElementVNode("button", {
                                      class: "image-remove",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.removeActivityImage(activity.id, imgIndex)),
                                      "aria-label": "Remover foto"
                                    }, [...(_cache[101] || (_cache[101] = [
                                      _createElementVNode("span", {
                                        class: "trash-icon",
                                        "aria-hidden": "true"
                                      }, null, -1)
                                    ]))], 8, _hoisted_99)
                                  ]))
                                }), 128)),
                                (activity.images.length < 25)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "image-add",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.triggerImageInput(activity.id))
                                    }, [...(_cache[102] || (_cache[102] = [
                                      _createElementVNode("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M9 4v10M4 9h10",
                                          stroke: "currentColor",
                                          "stroke-width": "1.6",
                                          "stroke-linecap": "round"
                                        })
                                      ], -1)
                                    ]))], 8, _hoisted_100))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_97),
                              _createElementVNode("input", {
                                id: `file-${activity.id}`,
                                class: "hidden-input",
                                type: "file",
                                accept: "image/*",
                                multiple: "",
                                onChange: ($event: any) => (_ctx.onImagesSelected(activity.id, $event))
                              }, null, 40, _hoisted_101)
                            ])
                          ])
                        ], 2)
                      ], 42, _hoisted_79)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-add-bottom",
              type: "button",
              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.addActivity && _ctx.addActivity(...args)))
            }, [...(_cache[104] || (_cache[104] = [
              _createElementVNode("svg", {
                width: "12",
                height: "12",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M7 3v8M3 7h8",
                  stroke: "currentColor",
                  "stroke-width": "1.4",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Adicionar atividade ", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              _cache[105] || (_cache[105] = _createElementVNode("div", { class: "section-label" }, "Observações", -1)),
              _createElementVNode("button", {
                class: "btn-inline",
                type: "button",
                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.addObservation && _ctx.addObservation(...args)))
              }, "+ Adicionar")
            ]),
            (_ctx.observations.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.observations, (section, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `obs-${section.id}`,
                      class: _normalizeClass(["item-row-wrap", { 'item-row-wrap--removing': _ctx.deletingId === section.id }])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-row", { 'item-row--drag-over': _ctx.dragSrcType === 'observations' && _ctx.dragOverItemIdx === index && _ctx.dragSrcIdx !== index }]),
                        draggable: "true",
                        onDragstart: ($event: any) => (_ctx.onItemDragStart(index, 'observations', $event)),
                        onDragover: _withModifiers(($event: any) => (_ctx.onItemDragOver(index, 'observations')), ["prevent"]),
                        onDrop: _withModifiers(($event: any) => (_ctx.onItemDrop(index, 'observations')), ["prevent"]),
                        onDragend: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.onItemDragEnd && _ctx.onItemDragEnd(...args)))
                      }, [
                        _cache[112] || (_cache[112] = _createStaticVNode("<div class=\"drag-handle\" title=\"Arrastar para reordenar\" data-v-223c034c><svg width=\"10\" height=\"14\" viewBox=\"0 0 10 14\" fill=\"none\" data-v-223c034c><circle cx=\"3\" cy=\"3\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"3\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"3\" cy=\"7\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"7\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"3\" cy=\"11\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle><circle cx=\"7\" cy=\"11\" r=\"1.4\" fill=\"currentColor\" data-v-223c034c></circle></svg></div>", 1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["flip-card", { 'flip-card--flipped': _ctx.deletePending?.type === 'observations' && _ctx.deletePending.index === index }])
                        }, [
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("p", _hoisted_107, "Remover observação " + _toDisplayString(index + 1) + "?", 1),
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("button", {
                                class: "flip-btn flip-btn--yes",
                                type: "button",
                                onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                              }, "Sim, remover"),
                              _createElementVNode("button", {
                                class: "flip-btn flip-btn--no",
                                type: "button",
                                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
                              }, "Não")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("div", _hoisted_110, [
                              _createElementVNode("div", _hoisted_111, _toDisplayString(index + 1), 1),
                              _createElementVNode("span", _hoisted_112, "Observação " + _toDisplayString(index + 1), 1),
                              (_ctx.canUseIA && _ctx.observations[index].text.trim())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn-ai-item",
                                    type: "button",
                                    disabled: _ctx.iaRewrite?.type === 'observations' && _ctx.iaRewrite.index === index && _ctx.iaRewrite.loading,
                                    onClick: ($event: any) => (_ctx.triggerIaRewrite('observations', index))
                                  }, [
                                    _cache[106] || (_cache[106] = _createElementVNode("svg", {
                                      width: "11",
                                      height: "11",
                                      viewBox: "0 0 14 14",
                                      fill: "none"
                                    }, [
                                      _createElementVNode("path", {
                                        d: "M7 1v2M7 11v2M1 7h2M11 7h2M2.8 2.8l1.4 1.4M9.8 9.8l1.4 1.4M2.8 11.2l1.4-1.4M9.8 4.2l1.4-1.4",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3",
                                        "stroke-linecap": "round"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.iaRewrite?.type === 'observations' && _ctx.iaRewrite.index === index && _ctx.iaRewrite.loading ? 'Processando…' : 'Modo IA'), 1)
                                  ], 8, _hoisted_113))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "item-remove-btn",
                                type: "button",
                                onClick: ($event: any) => (_ctx.askDelete('observations', index)),
                                title: "Remover"
                              }, [...(_cache[107] || (_cache[107] = [
                                _createElementVNode("svg", {
                                  width: "13",
                                  height: "13",
                                  viewBox: "0 0 14 14",
                                  fill: "none"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M2 3.5h10M5.5 3.5V2.5h3V3.5M4.5 3.5v7.5h5V3.5",
                                    stroke: "currentColor",
                                    "stroke-width": "1.3",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  })
                                ], -1),
                                _createTextVNode(" Remover ", -1)
                              ]))], 8, _hoisted_114)
                            ]),
                            _createElementVNode("div", _hoisted_115, [
                              _createElementVNode("label", {
                                for: `obs-text-${section.id}`
                              }, "Texto", 8, _hoisted_116),
                              _withDirectives(_createElementVNode("textarea", {
                                id: `obs-text-${section.id}`,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.observations[index].text) = $event),
                                class: "item-textarea",
                                placeholder: "Observação",
                                rows: "3"
                              }, null, 8, _hoisted_117), [
                                [_vModelText, _ctx.observations[index].text]
                              ]),
                              (_ctx.iaRewrite && _ctx.iaRewrite.type === 'observations' && _ctx.iaRewrite.index === index && !_ctx.iaRewrite.loading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                    _cache[108] || (_cache[108] = _createElementVNode("div", { class: "ia-suggestion-label" }, [
                                      _createElementVNode("svg", {
                                        width: "11",
                                        height: "11",
                                        viewBox: "0 0 14 14",
                                        fill: "none"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M7 1v2M7 11v2M1 7h2M11 7h2M2.8 2.8l1.4 1.4M9.8 9.8l1.4 1.4M2.8 11.2l1.4-1.4M9.8 4.2l1.4-1.4",
                                          stroke: "currentColor",
                                          "stroke-width": "1.3",
                                          "stroke-linecap": "round"
                                        })
                                      ]),
                                      _createTextVNode(" Sugestão da IA ")
                                    ], -1)),
                                    _createElementVNode("p", _hoisted_119, _toDisplayString(_ctx.iaRewrite.result), 1),
                                    _createElementVNode("div", _hoisted_120, [
                                      _createElementVNode("button", {
                                        class: "ia-btn ia-btn--accept",
                                        type: "button",
                                        onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.acceptIaRewrite && _ctx.acceptIaRewrite(...args)))
                                      }, "Manter"),
                                      _createElementVNode("button", {
                                        class: "ia-btn ia-btn--dismiss",
                                        type: "button",
                                        onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.dismissIaRewrite && _ctx.dismissIaRewrite(...args)))
                                      }, "Descartar")
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_121, [
                              _createElementVNode("label", null, [
                                _cache[109] || (_cache[109] = _createTextVNode("Fotos ", -1)),
                                _createElementVNode("span", _hoisted_122, _toDisplayString(section.images.length) + "/25", 1)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["image-grid", { 'is-drag-over': _ctx.dragOverObsId === section.id }]),
                                onDragenter: _withModifiers(($event: any) => (_ctx.dragOverObsId = section.id), ["prevent"]),
                                onDragover: _withModifiers(($event: any) => (_ctx.dragOverObsId = section.id), ["prevent"]),
                                onDragleave: _withModifiers(($event: any) => (_ctx.dragOverObsId = _ctx.dragOverObsId === section.id ? '' : _ctx.dragOverObsId), ["prevent"]),
                                onDrop: _withModifiers(($event: any) => (_ctx.onObsImagesDropped(section.id, $event)), ["prevent"])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.images, (img, imgIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: `obs-${section.id}-img-${imgIndex}`,
                                    class: "image-preview"
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.resolveUrl(img),
                                      alt: "preview"
                                    }, null, 8, _hoisted_124),
                                    _createElementVNode("button", {
                                      class: "image-remove",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.removeObsImage(section.id, imgIndex)),
                                      "aria-label": "Remover foto"
                                    }, [...(_cache[110] || (_cache[110] = [
                                      _createElementVNode("span", {
                                        class: "trash-icon",
                                        "aria-hidden": "true"
                                      }, null, -1)
                                    ]))], 8, _hoisted_125)
                                  ]))
                                }), 128)),
                                (section.images.length < 25)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "image-add",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.triggerObsImageInput(section.id))
                                    }, [...(_cache[111] || (_cache[111] = [
                                      _createElementVNode("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M9 4v10M4 9h10",
                                          stroke: "currentColor",
                                          "stroke-width": "1.6",
                                          "stroke-linecap": "round"
                                        })
                                      ], -1)
                                    ]))], 8, _hoisted_126))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_123),
                              _createElementVNode("input", {
                                id: `file-obs-${section.id}`,
                                class: "hidden-input",
                                type: "file",
                                accept: "image/*",
                                multiple: "",
                                onChange: ($event: any) => (_ctx.onObsImagesSelected(section.id, $event))
                              }, null, 40, _hoisted_127)
                            ])
                          ])
                        ], 2)
                      ], 42, _hoisted_105)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-add-bottom",
              type: "button",
              onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.addObservation && _ctx.addObservation(...args)))
            }, [...(_cache[113] || (_cache[113] = [
              _createElementVNode("svg", {
                width: "12",
                height: "12",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M7 3v8M3 7h8",
                  stroke: "currentColor",
                  "stroke-width": "1.4",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Adicionar observação ", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_128, [
            _createElementVNode("div", _hoisted_129, [
              _cache[114] || (_cache[114] = _createElementVNode("div", { class: "section-label" }, "Requisição de Itens", -1)),
              _createElementVNode("button", {
                class: "btn-inline",
                type: "button",
                onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.addRequestedItem && _ctx.addRequestedItem(...args)))
              }, "+ Adicionar")
            ]),
            (_ctx.requestedItems.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_130, " Faltou alguma ferramenta ou material? Adicione aqui os itens que precisam ser comprados — ao enviar o relatório, uma requisição de compra será criada automaticamente no Escritório. "))
              : _createCommentVNode("", true),
            (_ctx.requestedItems.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestedItems, (reqItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `req-${reqItem.id}`,
                      class: _normalizeClass(["item-row-wrap", { 'item-row-wrap--removing': _ctx.deletingId === reqItem.id }])
                    }, [
                      _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flip-card", { 'flip-card--flipped': _ctx.deletePending?.type === 'requestedItems' && _ctx.deletePending.index === index }])
                        }, [
                          _createElementVNode("div", _hoisted_133, [
                            _createElementVNode("p", _hoisted_134, "Remover item " + _toDisplayString(index + 1) + "?", 1),
                            _createElementVNode("div", _hoisted_135, [
                              _createElementVNode("button", {
                                class: "flip-btn flip-btn--yes",
                                type: "button",
                                onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                              }, "Sim, remover"),
                              _createElementVNode("button", {
                                class: "flip-btn flip-btn--no",
                                type: "button",
                                onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
                              }, "Não")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_136, [
                            _createElementVNode("div", _hoisted_137, [
                              _createElementVNode("div", _hoisted_138, _toDisplayString(index + 1), 1),
                              _createElementVNode("span", _hoisted_139, _toDisplayString(reqItem.nome || `Item ${index + 1}`), 1),
                              _createElementVNode("button", {
                                class: "item-remove-btn",
                                type: "button",
                                onClick: ($event: any) => (_ctx.askDelete('requestedItems', index)),
                                title: "Remover"
                              }, [...(_cache[115] || (_cache[115] = [
                                _createElementVNode("svg", {
                                  width: "13",
                                  height: "13",
                                  viewBox: "0 0 14 14",
                                  fill: "none"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M2 3.5h10M5.5 3.5V2.5h3V3.5M4.5 3.5v7.5h5V3.5",
                                    stroke: "currentColor",
                                    "stroke-width": "1.3",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  })
                                ], -1),
                                _createTextVNode(" Remover ", -1)
                              ]))], 8, _hoisted_140)
                            ]),
                            _createElementVNode("div", _hoisted_141, [
                              _createElementVNode("label", {
                                for: `req-nome-${reqItem.id}`
                              }, "Nome do item *", 8, _hoisted_142),
                              _withDirectives(_createElementVNode("input", {
                                id: `req-nome-${reqItem.id}`,
                                "onUpdate:modelValue": ($event: any) => ((reqItem.nome) = $event),
                                type: "text",
                                placeholder: "Ex.: Furadeira de impacto 220V"
                              }, null, 8, _hoisted_143), [
                                [_vModelText, reqItem.nome]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_144, [
                              _createElementVNode("label", {
                                for: `req-desc-${reqItem.id}`
                              }, "Descrição", 8, _hoisted_145),
                              _withDirectives(_createElementVNode("textarea", {
                                id: `req-desc-${reqItem.id}`,
                                "onUpdate:modelValue": ($event: any) => ((reqItem.descricao) = $event),
                                class: "item-textarea",
                                placeholder: "Detalhes do item (marca, modelo, especificações…)",
                                rows: "2"
                              }, null, 8, _hoisted_146), [
                                [_vModelText, reqItem.descricao]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_147, [
                              _createElementVNode("label", {
                                for: `req-link-${reqItem.id}`
                              }, "Link", 8, _hoisted_148),
                              _withDirectives(_createElementVNode("input", {
                                id: `req-link-${reqItem.id}`,
                                "onUpdate:modelValue": ($event: any) => ((reqItem.link) = $event),
                                type: "url",
                                placeholder: "https://…"
                              }, null, 8, _hoisted_149), [
                                [_vModelText, reqItem.link]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_150, [
                              _createElementVNode("label", null, [
                                _cache[116] || (_cache[116] = _createTextVNode("Fotos ", -1)),
                                _createElementVNode("span", _hoisted_151, _toDisplayString(reqItem.images.length) + "/25", 1)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["image-grid", { 'is-drag-over': _ctx.dragOverReqId === reqItem.id }]),
                                onDragenter: _withModifiers(($event: any) => (_ctx.dragOverReqId = reqItem.id), ["prevent"]),
                                onDragover: _withModifiers(($event: any) => (_ctx.dragOverReqId = reqItem.id), ["prevent"]),
                                onDragleave: _withModifiers(($event: any) => (_ctx.dragOverReqId = _ctx.dragOverReqId === reqItem.id ? '' : _ctx.dragOverReqId), ["prevent"]),
                                onDrop: _withModifiers(($event: any) => (_ctx.onReqImagesDropped(reqItem.id, $event)), ["prevent"])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reqItem.images, (img, imgIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: `req-${reqItem.id}-img-${imgIndex}`,
                                    class: "image-preview"
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.resolveUrl(img),
                                      alt: "preview"
                                    }, null, 8, _hoisted_153),
                                    _createElementVNode("button", {
                                      class: "image-remove",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.removeReqImage(reqItem.id, imgIndex)),
                                      "aria-label": "Remover foto"
                                    }, [...(_cache[117] || (_cache[117] = [
                                      _createElementVNode("span", {
                                        class: "trash-icon",
                                        "aria-hidden": "true"
                                      }, null, -1)
                                    ]))], 8, _hoisted_154)
                                  ]))
                                }), 128)),
                                (reqItem.images.length < 25)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "image-add",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.triggerReqImageInput(reqItem.id))
                                    }, [...(_cache[118] || (_cache[118] = [
                                      _createElementVNode("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M9 4v10M4 9h10",
                                          stroke: "currentColor",
                                          "stroke-width": "1.6",
                                          "stroke-linecap": "round"
                                        })
                                      ], -1)
                                    ]))], 8, _hoisted_155))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_152),
                              _createElementVNode("input", {
                                id: `file-req-${reqItem.id}`,
                                class: "hidden-input",
                                type: "file",
                                accept: "image/*",
                                multiple: "",
                                onChange: ($event: any) => (_ctx.onReqImagesSelected(reqItem.id, $event))
                              }, null, 40, _hoisted_156)
                            ])
                          ])
                        ], 2)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-add-bottom",
              type: "button",
              onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.addRequestedItem && _ctx.addRequestedItem(...args)))
            }, [...(_cache[119] || (_cache[119] = [
              _createElementVNode("svg", {
                width: "12",
                height: "12",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M7 3v8M3 7h8",
                  stroke: "currentColor",
                  "stroke-width": "1.4",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Adicionar item ", -1)
            ]))])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                _cache[120] || (_cache[120] = _createElementVNode("svg", {
                  width: "15",
                  height: "15",
                  viewBox: "0 0 15 15",
                  fill: "none"
                }, [
                  _createElementVNode("circle", {
                    cx: "7.5",
                    cy: "7.5",
                    r: "6",
                    stroke: "currentColor",
                    "stroke-width": "1.3"
                  }),
                  _createElementVNode("path", {
                    d: "M7.5 5v3.5M7.5 10.5v.5",
                    stroke: "currentColor",
                    "stroke-width": "1.4",
                    "stroke-linecap": "round"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
              ]))
            : _createCommentVNode("", true)
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_158, [
        _createElementVNode("div", _hoisted_159, [
          _createElementVNode("button", {
            class: "sfv-bb-btn sfv-bb-btn--ghost",
            type: "button",
            onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
            disabled: _ctx.isSaving
          }, " Cancelar ", 8, _hoisted_160),
          (_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "sfv-bb-btn sfv-bb-btn--danger",
                type: "button",
                onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
                disabled: _ctx.isSaving
              }, [...(_cache[121] || (_cache[121] = [
                _createElementVNode("svg", {
                  width: "13",
                  height: "13",
                  viewBox: "0 0 14 14",
                  fill: "none"
                }, [
                  _createElementVNode("path", {
                    d: "M2 3.5h10M5.5 3.5V2.5h3V3.5M4.5 3.5v7.5h5V3.5",
                    stroke: "currentColor",
                    "stroke-width": "1.3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1),
                _createTextVNode(" Excluir ", -1)
              ]))], 8, _hoisted_161))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_162, [
          _createElementVNode("button", {
            class: "sfv-bb-btn sfv-bb-btn--secondary",
            type: "button",
            onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args))),
            disabled: _ctx.isSaving
          }, [...(_cache[122] || (_cache[122] = [
            _createElementVNode("svg", {
              width: "13",
              height: "13",
              viewBox: "0 0 14 14",
              fill: "none"
            }, [
              _createElementVNode("path", {
                d: "M3 7h8M7 3v8",
                stroke: "currentColor",
                "stroke-width": "1.3",
                "stroke-linecap": "round"
              })
            ], -1),
            _createTextVNode(" Salvar rascunho ", -1)
          ]))], 8, _hoisted_163),
          _createElementVNode("button", {
            class: "sfv-bb-btn sfv-bb-btn--primary",
            type: "button",
            onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args))),
            disabled: _ctx.isSaving
          }, [...(_cache[123] || (_cache[123] = [
            _createTextVNode(" Enviar relatório ", -1),
            _createElementVNode("svg", {
              width: "13",
              height: "13",
              viewBox: "0 0 14 14",
              fill: "none"
            }, [
              _createElementVNode("path", {
                d: "M5 3l5 4-5 4",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]))], 8, _hoisted_164)
        ])
      ]),
      _createVNode(_component_NoticeModal, {
        open: _ctx.noticeOpen,
        title: _ctx.noticeMessage,
        "button-text": "Entendi",
        onClose: _cache[47] || (_cache[47] = ($event: any) => (_ctx.noticeOpen = false))
      }, null, 8, ["open", "title"]),
      _createVNode(_Transition, { name: "autosave-toast" }, {
        default: _withCtx(() => [
          (_ctx.showToolRequestPrompt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                _cache[125] || (_cache[125] = _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" })
                ], -1)),
                _cache[126] || (_cache[126] = _createElementVNode("span", { class: "tool-request-text" }, "Faltou alguma ferramenta?", -1)),
                _createElementVNode("button", {
                  class: "tool-request-yes",
                  type: "button",
                  onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.acceptToolRequestPrompt && _ctx.acceptToolRequestPrompt(...args)))
                }, "Sim"),
                _createElementVNode("button", {
                  class: "tool-request-close",
                  type: "button",
                  onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.showToolRequestPrompt = false)),
                  "aria-label": "Fechar"
                }, [...(_cache[124] || (_cache[124] = [
                  _createElementVNode("svg", {
                    width: "11",
                    height: "11",
                    viewBox: "0 0 10 10",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M2 2l6 6M8 2L2 8",
                      stroke: "currentColor",
                      "stroke-width": "1.6",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "autosave-toast" }, {
        default: _withCtx(() => [
          (_ctx.autoSaveStatus !== 'idle')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["autosave-toast", `autosave-toast--${_ctx.autoSaveStatus}`])
              }, [
                (_ctx.autoSaveStatus === 'saving')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[127] || (_cache[127] = _createElementVNode("svg", {
                        class: "spin-icon",
                        width: "13",
                        height: "13",
                        viewBox: "0 0 20 20",
                        fill: "none"
                      }, [
                        _createElementVNode("circle", {
                          cx: "10",
                          cy: "10",
                          r: "8",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-dasharray": "40",
                          "stroke-dashoffset": "15",
                          "stroke-linecap": "round"
                        })
                      ], -1)),
                      _cache[128] || (_cache[128] = _createTextVNode(" Salvando rascunho… ", -1))
                    ], 64))
                  : (_ctx.autoSaveStatus === 'saved')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[129] || (_cache[129] = _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 12 12",
                          fill: "none"
                        }, [
                          _createElementVNode("path", {
                            d: "M2 6l3 3 5-5",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ], -1)),
                        _createTextVNode(" Rascunho salvo às " + _toDisplayString(_ctx.autoSaveTime), 1)
                      ], 64))
                    : (_ctx.autoSaveStatus === 'error')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _cache[130] || (_cache[130] = _createElementVNode("svg", {
                            width: "13",
                            height: "13",
                            viewBox: "0 0 12 12",
                            fill: "none"
                          }, [
                            _createElementVNode("circle", {
                              cx: "6",
                              cy: "6",
                              r: "5",
                              stroke: "currentColor",
                              "stroke-width": "1.3"
                            }),
                            _createElementVNode("path", {
                              d: "M6 4v2.5M6 8.5v.5",
                              stroke: "currentColor",
                              "stroke-width": "1.3",
                              "stroke-linecap": "round"
                            })
                          ], -1)),
                          _cache[131] || (_cache[131] = _createTextVNode(" Erro ao salvar rascunho ", -1))
                        ], 64))
                      : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2)
  ], 64))
}